"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useSpacerStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    normal: _defineProperty({
      height: theme.spacing(8)
    }, theme.breakpoints.up('sm'), {
      height: theme.spacing(8)
    }),
    small: _defineProperty({
      height: theme.spacing(4)
    }, theme.breakpoints.up('sm'), {
      height: theme.spacing(4)
    })
  };
});
var Spacer = function Spacer(_ref) {
  var _ref$small = _ref.small,
    small = _ref$small === void 0 ? false : _ref$small;
  var classes = useSpacerStyles();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: small ? classes.small : classes.normal
  });
};
var _default = Spacer;
exports.default = _default;